import { render, staticRenderFns } from "./DubaiSelect.vue?vue&type=template&id=acc44de2&scoped=true&"
import script from "./DubaiSelect.vue?vue&type=script&lang=js&"
export * from "./DubaiSelect.vue?vue&type=script&lang=js&"
import style0 from "./DubaiSelect.vue?vue&type=style&index=0&id=acc44de2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc44de2",
  null
  
)

export default component.exports